import React from "react";

export function PageHeader({ eyebrow, title, description, action, testId }) {
  return (
    <div
      className="flex flex-wrap items-end justify-between gap-6 mb-10"
      data-testid={testId || "page-header"}
    >
      <div className="min-w-0">
        {eyebrow && <div className="label-eyebrow text-[#C5A059] mb-2">{eyebrow}</div>}
        <h1 className="font-serif text-4xl md:text-5xl tracking-tight font-medium">{title}</h1>
        {description && (
          <p className="mt-3 text-[#2A0F5A]/70 max-w-2xl">{description}</p>
        )}
      </div>
      {action && <div>{action}</div>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, description, action, testId }) {
  return (
    <div
      className="border border-dashed border-[#E8E3F0] p-12 text-center bg-white"
      data-testid={testId || "empty-state"}
    >
      {Icon && <Icon size={28} strokeWidth={1.4} className="mx-auto mb-4 text-[#C5A059]" />}
      <div className="font-serif text-2xl mb-2">{title}</div>
      {description && <div className="text-sm text-[#4A5568] max-w-md mx-auto">{description}</div>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

export function Stat({ label, value, testId }) {
  return (
    <div className="border border-[#E8E3F0] bg-white p-5" data-testid={testId}>
      <div className="label-eyebrow mb-2">{label}</div>
      <div className="font-serif text-4xl tracking-tight">{value}</div>
    </div>
  );
}

export function StatusBadge({ children, tone = "neutral" }) {
  const tones = {
    neutral: "bg-[#FAFAF8] text-[#2A0F5A] border-[#E8E3F0]",
    active: "bg-[#2A0F5A] text-[#FAFAF8] border-[#2A0F5A]",
    warn: "bg-[#C5A059]/15 text-[#8a6b1f] border-[#C5A059]/40",
    success: "bg-[#DEEBE2] text-[#215a3b] border-[#BEDCC7]",
    danger: "bg-[#F8E4E4] text-[#8a2121] border-[#EEC7C7]",
  };
  return (
    <span
      className={`inline-block text-[10px] tracking-[0.18em] uppercase font-semibold px-2 py-1 border ${tones[tone] || tones.neutral}`}
    >
      {children}
    </span>
  );
}
